import { jackpotWinsStates } from '@namespace/bonuses';
import { postAsJson } from '@namespace/helpers';
import { IApiResponse, JackpotWin } from '../../../types';

export const getJackpotWins = (
  jackpotStatuses = {
    status: [
      jackpotWinsStates.ACCEPTED,
      jackpotWinsStates.AVAILABLE,
      jackpotWinsStates.EXPIRED
    ]
  }
): Promise<IApiResponse<JackpotWin[]>> => {
  return postAsJson('/service/jackpot/api/jackpot-wins/get', jackpotStatuses);
};
